export const InitialState = {
    me: null
};
